import _recaptcha from './recaptcha.service';
export const recaptcha = _recaptcha;